import { ReactComponent as Shield } from "../../assets/images/shield.svg";
import { IconProps } from "./types";

const ShieldIcon: React.FC<IconProps> = ({ className }) => {
  return <Shield className={className} />;
};

export default ShieldIcon;
